<template>
  <div>
    <b-card header-class="border-0">
      <b-row>
        <b-col>
          <base-input
            label="Payment Plan ID"
            v-debounce:500ms="setPaymentPlanId"
            v-model="id"
          >
          </base-input>
        </b-col>
        <b-col>
          <base-input label="Patient">
            <customerSelect v-on:nameSelected="nameSelected"></customerSelect>
            <small>Search by first name or e-mail</small>
          </base-input>
        </b-col>
        <b-col>
          <label class="form-control-label">Created Start Date</label>
          <b-form-datepicker
            id="startDate"
            class="col-sm-12"
            v-model="form.startDate"
            locale="en"
          ></b-form-datepicker>
        </b-col>
        <b-col>
          <label class="form-control-label">Created End Date</label>
          <b-form-datepicker
            id="endDate"
            class="col-sm-12"
            v-model="form.endDate"
            locale="en"
          ></b-form-datepicker>
        </b-col>
        <b-col>
          <label class="form-control-label">Status</label>
          <b-form-checkbox-group
            :options="statusOptions"
            v-model="form.statuses"
          />
          <br />
          <b-form-checkbox v-model="form.isPastDue"
            >Past Due Payment Plans</b-form-checkbox
          >
        </b-col>
      </b-row>
    </b-card>

    <b-card body-class="p-0" header-class="border-0">
      <paymentPlan-search-results
        :query="form"
        ref="searchResults"
        @paymentPlanSelected="paymentPlanSelected"
      />
    </b-card>
  </div>
</template>
<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import SearchResults from "@/views/Components/PaymentPlans/SearchResults";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  name: "light-table",
  title: "Payment Plans",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    flatPicker,
    "paymentPlan-search-results": SearchResults,
  },
  props: {
    itemLimit: {
      type: Number,
      default: 9,
    },
  },
  data() {
    return {
      statusOptions: [
        {
          text: "Active",
          value: "ACTIVE",
        },

        {
          text: "Complete",
          value: "COMPLETE",
        },
        {
          text: "Canceled",
          value: "INACTIVE",
        },
      ],
      id: null,
      form: {
        id: null,
        startDate: null,
        endDate: null,
        customerId: null,
        isPastDue: false,
        statuses: ["ACTIVE", "COMPLETE"],
      },
    };
  },
  mounted() {
    var self = this;
    if (this.$route.query.isPastDue == "true") this.form.isPastDue = true;
  },
  methods: {
    setPaymentPlanId() {
      if (this.id == "") this.form.id = null;
      else this.form.id = this.id;
    },
    nameSelected(customer) {
      this.form.customerId = customer.id;
    },
  },
};
</script>
